import React from 'react';
import { Box } from '@mui/material';
import { getProductoFallbackImage, getProductoImageBySize } from '../../../../utils/productImage';
import type { ProductoInfo360Maestro } from './ArticuloInfo360Header';

interface Props {
  producto: ProductoInfo360Maestro;
  size?: 'thumbnail' | 'medium' | 'full';
  dimension?: number;
}

const ProductoInfo360Thumbnail: React.FC<Props> = ({
  producto,
  size = 'thumbnail',
  dimension = 72,
}) => {
  const fallbackSrc = getProductoFallbackImage();
  const initialSrc = getProductoImageBySize(producto, size) || fallbackSrc;

  return (
    <Box
      sx={{
        width: dimension,
        height: dimension,
        borderRadius: 1.5,
        border: '1px solid #e0e0e0',
        overflow: 'hidden',
        bgcolor: '#f5f5f5',
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        key={`${producto.codigoArticulo}-${initialSrc}`}
        src={initialSrc}
        alt={`Foto de ${producto.codigoArticulo}`}
        loading="lazy"
        onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
          const target = event.currentTarget;
          target.onerror = null;
          target.src = fallbackSrc;
        }}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </Box>
  );
};

export default ProductoInfo360Thumbnail;
